// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","violet":"#7112ff","bgViolet":"#7112ff07","lightViolet":"#7112ff33","red":"#c30101","lightRed":"#c3010133","green":"#4ec200","lightGreen":"#4ec20033"};